import * as H from "history";
import * as React from "react";
import {
  useMappedState,
  useDispatch
} from "redux-react-hook";

import { Modal } from "src/library/components/Modal";
import type { IStore } from "src/core/shared/store";
import { MenuContext } from "src/core/shared/hooks/menu/useMenu";
import { IRoute } from "src/pages/Router/routes";

import { setGlobalModal } from "../store/global/global.actions";

interface IGlobalContextModalProps {
  history: H.History;
  routes: IRoute[];
}

const GlobalContextModal: React.ReactFCWithChildren<IGlobalContextModalProps> = () => {
  const { contextModal } = useMappedState((store: IStore) => store.global);
  const [ _menuContext, { removeCurrentContext } ] = React.useContext(MenuContext);
  const dispatch = useDispatch();

  const handleNo = React.useCallback(() => {
    dispatch(setGlobalModal(null));
  }, [ dispatch, setGlobalModal ]);

  return (
    <>
      {contextModal && (
        <Modal
          small
          actions={[
            {
              name: "Yes",
              action: () => removeCurrentContext(true),
              $buttonType: "primary"
            },
            {
              name: "No",
              action: () => handleNo(),
              $buttonType: "secondary"
            }
          ]}
          backgroundAction={() => handleNo()}
          body={contextModal.details}
          type="confirm"
          title={contextModal.title}
          show={contextModal !== null}
        />
      )}
    </>
  );
};

export default GlobalContextModal;
